module.exports = __webpack_public_path__ + "img/introduce-icon4.f749df1e.png";